import React, { ComponentProps } from 'react'

import { Box, Container, FormControl, Grid, styled } from '@mui/material'

import { Button } from '../Button/Button'
import { TextField } from '../TextField/TextField'

export type FooterSubscribeProps = Omit<ComponentProps<typeof Grid>, 'justifyContent' | 'alignItems'> & {
  //
}

export const FooterSubscribe: React.FC<FooterSubscribeProps> = ({ ...props }) => {
  const onSubscribe = () => {
    // TODO: add a Subscribe event
  }

  return (
    <StyledWrapperBox>
      <Container maxWidth="lg">
        <Grid container justifyContent="center" alignItems="center" {...props}>
          <StyledGrid item >
            <StyledFormControl>
              <StyledTextField
                type="email"
                placeholder="Your email address"
              />
              <StyledMobileSubscribeButton onSubmit={onSubscribe}>
                Subscribe
              </StyledMobileSubscribeButton>
            </StyledFormControl>
            <StyledDesktopSubscribeButton primary size="large" onSubmit={onSubscribe}>
              Subscribe
            </StyledDesktopSubscribeButton>
          </StyledGrid>
        </Grid>
      </Container>
    </StyledWrapperBox>
  )
}

const StyledFormControl = styled(FormControl)`
  width: 100%;
  display: inline-flex;
  position: relative;
  justify-content: center;
  align-items: center;

  ${(props) => props.theme.breakpoints.up('sm')} {
    width: auto;
  }
`

const StyledGrid = styled(Grid)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  ${(props) => props.theme.breakpoints.up('sm')} {
    width: unset;
  }
`

const StyledWrapperBox = styled(Box)`
  width: 100%;
  background-color: ${(props) => props.theme.palette.custom.accentyellow};
  padding: ${(props) => props.theme.typography.pxToRem(56)} 0;

  ${(props) => props.theme.breakpoints.up('sm')} {
    padding: ${(props) => props.theme.typography.pxToRem(44)} 0;
  }
`

const StyledDesktopSubscribeButton = styled(Button)`
  display: none;

  ${(props) => props.theme.breakpoints.up('sm')} {
    display: unset;
    margin-left: ${(props) => props.theme.typography.pxToRem(16)};
  }
`

const StyledTextField = styled(TextField)`
  width: 100%;

  ${(props) => props.theme.breakpoints.up('sm')} {
    width: auto;
    min-width: ${(props) => props.theme.typography.pxToRem(440)};
  }
`

const StyledMobileSubscribeButton = styled(Button)`
  position: absolute;
  right: 0;

  ${(props) => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`
